const Skill = ({ name, icon, index }) => {
  return (
    <div className="skill" style={{ "--order": index }}>
      <i className={icon}></i>
      <p>{name}</p>
    </div>
  );
};

export default Skill;
